const PY = require('pinyin-pro')
const Staff = require('@/tbs/model/to/Staff')
const staff = new Staff
/**
 * The Staff class acts as the view object for the staff.
 */
const tbs_model_vo_Staff = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Staff.prototype = {
    /* The view object name */
    name: 'staff',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccountContactList',
            basePath: 'data.list',
            rule: {
                id: 'id',
                name: 'name',
                logoUrl: 'avatar',
                role: '$roleIds',
                roleLabel: '$roleIds',
                remark: 'remark',
                isLogon: '$userId',
                isSuperAdmin: '$roleIds',
                firstLetter: '$name',
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getCrmAccountContact',
            basePath: 'data',
            rule: {
                id: 'contact.id',
                organizationId: 'contact.accountId',
                name: 'contact.name',
                logoUrl: 'contact.avatar',
                role: '$contact.roleIds',
                roleLabel: '$contact.roleIds',
                remark: 'contact.remark',
                isLogon: '$contact.userId',
                matchList: '$matchList'
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'CreateCrmAccountContact',
            basePath: '',
            rule: {
                accountId: 'organizationId',
                name: 'name',
                avatar: 'logoUrl',
                roleIds: '$role',
                role: '$role',
                remark: 'remark',
                status: '(0)',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateCrmAccountContact',
            basePath: '',
            rule: {
                id: 'id',
                name: 'name',
                avatar: 'logoUrl',
                roleIds: '$role',
                role: '$role',
                remark: 'remark',
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateCrmAccountContactStatus',
            basePath: '',
            rule: {
                id: 'id',
                status: '(-2)'
            }
        },
        send: {
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'CreateMatchOrganizationManagerInvitation.json',
            basePath: 'data',
            rule: {
                organizationName: 'orgName',
                organizationLogoUrl: 'orgLogo',
                ticket: 'ticket'
            }
        },
        invite: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetMatchOrganizationManagerInvitationInfo2',
            method: 'get',
            basePath: 'data.info',
            rule: {
                organizationName: 'orgName',
                organizationLogoUrl: 'orgLogo',
                role: '$roleIds',
                roleLabel: '$roleIds',
                organizationEntyYear: '$createDate'
            }
        },
        accept: {
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'AcceptMatchOrganizationManagerInvitation.json',
            basePath: '',
            rule: {
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderOrganizationEntyYear: function(createDate) {
        return createDate.substr(0, 4)
    },
    renderMatchList: function(matchList) {
        const convertedMatchList = []
        for (let i = 0; i < matchList.length; i++) {
            let match = matchList[i]
            convertedMatchList.push({
                matchId: match.id
            })
        }
        return convertedMatchList
    },
    formatRoleIds: function(role) {
        return role == '1' ? '2' : '4'
    },
    formatRole: function(role) {
        return staff.localeProp('role-option-' + role)
    },
    renderFirstLetter: function(name) {
        const firstChar = name.substr(0, 1)
        const firstLetter = PY.pinyin(firstChar, { pattern: 'first', toneType: 'none' })
        // console.log('renderFirstLetter', name, firstLetter)
        return firstLetter
    },
    renderIsLogon: function(userId) {
        // console.log('renderIsLogon', userId, userId ? true : false)
        return userId ? true : false
    },
    renderIsSuperAdmin: function(roleIds) {
        return roleIds.indexOf('1') > -1
    },
    renderRole: function(roleIds) {
        if (roleIds.indexOf('1') > -1) {
            return '1'
        }
        else if (roleIds.indexOf('2') > -1) {
            return '1'
        }
        else if (roleIds.indexOf('4') > -1) {
            return '2'
        }
    },
    renderRoleLabel: function(roleIds) {
        let staffRole
        if (roleIds.indexOf('1') > -1) {
            staffRole = 0
        }
        else if (roleIds.indexOf('2') > -1) {
            staffRole = 1
        }
        else if (roleIds.indexOf('4') > -1) {
            staffRole = 2
        }
        return staff.localeProp('role-option-' + staffRole)
    },
    roleOptions: [
        { label: staff.localeProp('role-option-1'), value: '1'},
        { label: staff.localeProp('role-option-2'), value: '2'},
    ],
    getRoleOptions: function(type) {
        if (type == 'organization') {
            return this.roleOptions
        }
        else if (type == 'match') {
            return [
                { label: staff.localeProp('role-option-2'), value: '2'},
            ]
        }
    },
    localeProp: function(key, params) {
        return staff.localeProp(key, params)
    }
}

module.exports = tbs_model_vo_Staff